import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogoutPage: React.FunctionComponent = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = () => {
            try {
                // Clear localStorage
                localStorage.clear();

                // Notify parent window that logout is complete
                if (window.parent !== window) {
                    window.parent.postMessage("logout-complete", "*");
                }

                setTimeout(() => {
                    navigate('/login');
                }, 200);
            } catch (error) {
                console.error("Logout error:", error);
                navigate('/login');
            }
        };

        handleLogout();
    }, [navigate]);

    return (
        <div>
            <p>Signing out...</p>
        </div>
    );
};

export default LogoutPage;